import type { ModuleManifest } from "./types";

const workerGroupsManifest: ModuleManifest = {
  name: "worker-groups",
  label: "Gruppi Omogenei",
  labelPlural: "Gruppi Omogenei / Classi Incarico",
  coreBOSModule: "PersonalDataCategories",
  wsidPrefix: "70x",
  type: "standard",
  routes: {
    list: "/worker-groups",
    show: "/worker-groups/show/:id",
    create: "/worker-groups/create",
    edit: "/worker-groups/edit/:id",
  },
  navigation: {
    icon: "TeamOutlined",
    order: 22,
    group: "Sicurezza Lavoro",
  },
  routing: {
    keywords: ["worker-groups", "gruppi-omogenei", "classi-incarico", "personaldatacategories", "categorie"],
    searchFields: ["data_category_name"],
    defaultSort: { field: "data_category_name", order: "asc" },
  },
  context: { supported: true, entityKey: "worker-groups" },
  relationships: [],
  requiredFields: ["data_category_name"],
  viewStrategy: "bespoke",
  bespoke_justification:
    "Dual-use: GDPR classi-di-incarico vs DVR gruppi-omogenei. Bespoke list shows framework_tags filter chips, DPI badges, medical visit countdown.",
  fields: [
    { name: "data_category_name", label: "Nome Gruppo", type: "string", required: true },
    { name: "personaldatacategories_no", label: "Codice", type: "string" },
    { name: "relpdc_account", label: "Azienda", type: "reference", referenceModule: "Accounts" },
    { name: "framework_tags", label: "Framework", type: "multipicklist" },
    { name: "activity_type", label: "Tipo Attività", type: "string" },
    { name: "n_workers", label: "N. Lavoratori", type: "integer" },
    { name: "mansioni", label: "Mansioni", type: "text" },
    { name: "luoghi_lavoro", label: "Luoghi di Lavoro", type: "string" },
    { name: "orario_lavoro", label: "Orario", type: "picklist" },
    { name: "dpi_required", label: "DPI Richiesti", type: "multipicklist" },
    { name: "sorveglianza_sanitaria", label: "Sorv. Sanitaria", type: "boolean" },
    { name: "frequenza_visita", label: "Frequenza Visita", type: "picklist" },
    { name: "next_visit_group", label: "Prossima Visita", type: "date" },
    { name: "dvr_link", label: "DVR", type: "reference", referenceModule: "Audit" },
    { name: "pdclinktophysical", label: "Area Fisica", type: "reference" },
    { name: "istemplate", label: "Template", type: "boolean" },
    { name: "description", label: "Note", type: "text" },
  ],
};

export { workerGroupsManifest };
export default workerGroupsManifest;
